import appStore from 'store';
import api from './api';
import {

  QUERY_TYPE,
  PAGINATION
} from './constants';

const store = {
  namespaced: true,
  state: {
    userList: [],
    detailList: [],
    coinList: [],
    totalCount: 0,
    detailTotalCount: 0,
    pagination: PAGINATION,

  },
  getters: {

  },
  mutations: {
    setUserList(state, payload) {
      state.userList = payload.list.slice();
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setDetailList(state, payload) {
      state.detailList = payload.list?payload.list.slice():[];
      state.detailTotalCount = payload.totalCount;
    },
    setCoinList(state,payload){
      console.log('...pa',[...payload]);
      state.coinList=[...payload]
    }

  },
  actions: {
    list({ commit }, query = {}) {
      commit('setPagination', { page: query.page, size: query.size });
      api.getUserList(query).then(res => {
        console.log('res',res);
        if(res.code==0){
          commit('setUserList', res.data);
        }
      });
    },
    exportExcel({ commit }, data) {
      return api.exportExcel(data);
    },
    addRemark({commit},data){
     return api.addRemark(data).then(res=>{
        return res
      })
    },
    getDetail({commit},data){
      api.getDetail(data).then(res=>{
        if(res.code==0){
          commit('setDetailList', res.result);
        }
      })
    },
    getCoinList({commit},data){
      api.getCoinList(data).then(res=>{
          commit('setCoinList',res.data)
      })
    }
    
 
  }
};

appStore.registerModule('spotBill', store);
